import { Injectable } from '@angular/core';
import { GetLocReferenceDetailsBySicResp, LocationApiService } from '@xpo-ltl/sdk-location';
import { BaseCacheService } from '../utils/angular-utils/services';

import { Observable } from 'rxjs';

export interface LocationDetailsCacheParams {
  sicCd: string;
}

@Injectable()
export class LocationDetailsCacheService extends BaseCacheService<LocationDetailsCacheParams, GetLocReferenceDetailsBySicResp> {
  constructor(private locationService: LocationApiService) {
    super();
  }

  protected getKeyFromParams(params: LocationDetailsCacheParams): string {
    return params.sicCd.toUpperCase();
  }

  protected requestData(params: LocationDetailsCacheParams): Observable<GetLocReferenceDetailsBySicResp> {
    const request = { sicCd: null };
    request.sicCd = params.sicCd.toUpperCase();
    return this.locationService.getLocReferenceDetailsBySic(request, { toastOnError: false });
  }
}
